
<template>
  <div class="privacy">
    <!-- 标题部分 -->
    <div class="title">
      <h1>{{ $t('message.privacyTitle') }}</h1>
      <p>{{ $t('message.privacyUpdateDate') }}</p>
    </div>

    <!-- 1. Introduction -->
    <div class="introduction">
      <h2>{{ $t('message.privacyIntroductionTitle') }}</h2>
      <p>{{ $t('message.privacyIntroductionParagraph01') }}</p>
      <p>{{ $t('message.privacyIntroductionParagraph02') }}</p>
      <p>{{ $t('message.privacyIntroductionParagraph03') }}</p>
      <p>{{ $t('message.privacyIntroductionParagraph04') }}</p>
      <p>{{ $t('message.privacyIntroductionParagraph05') }}</p>
      <p>{{ $t('message.privacyIntroductionParagraph06') }}</p>
    </div>

    <!-- 2. Personal Info -->
    <div class="personalInfo">
      <h2>{{ $t('message.privacyPersonalInfoTitle') }}</h2>
      <p>{{ $t('message.privacyPersonalInfoParagraph01') }}</p>
      <h3>{{ $t('message.privacyPersonalInfo01Title') }}</h3>
      <p>{{ $t('message.privacyPersonalInfo01Paragraph01') }}</p>
      <table>
        <thead>
          <!-- 表格头部 -->
          <tr>
            <td>
              <strong>{{ $t('message.privacyPersonalInfo01Table01ColName01') }}</strong>
            </td>
            <td>
              <strong>{{ $t('message.privacyPersonalInfo01Table01ColName02') }}</strong>
            </td>
          </tr>
        </thead>
        <tbody>
          <!-- 表格主体 -->
          <tr>
            <td class="personalInfoTb2Col01">{{ $t('message.privacyPersonalInfo01Table01.typeOfData[0]') }}</td>
            <td class="personalInfoTb2Col02">{{ $t('message.privacyPersonalInfo01Table01.examplesOfData[0]') }}</td>
          </tr>
          <tr>
            <td class="personalInfoTb2Col01">{{ $t('message.privacyPersonalInfo01Table01.typeOfData[1]') }}</td>
            <td class="personalInfoTb2Col02">{{ $t('message.privacyPersonalInfo01Table01.examplesOfData[1]') }}</td>
          </tr>
          <tr>
            <td class="personalInfoTb2Col01">{{ $t('message.privacyPersonalInfo01Table01.typeOfData[2]') }}</td>
            <td class="personalInfoTb2Col02">{{ $t('message.privacyPersonalInfo01Table01.examplesOfData[2]') }}</td>
          </tr>
          <tr>
            <td class="personalInfoTb2Col01">{{ $t('message.privacyPersonalInfo01Table01.typeOfData[3]') }}</td>
            <td class="personalInfoTb2Col02">{{ $t('message.privacyPersonalInfo01Table01.examplesOfData[3]') }}</td>
          </tr>
        </tbody>
      </table>
      <br />
      <p>{{ $t('message.privacyPersonalInfo01Paragraph02') }}</p>
      <table>
        <thead>
          <!-- 表格头部 -->
          <tr>
            <td>
              <strong>{{ $t('message.privacyPersonalInfo01Table02ColName01') }}</strong>
            </td>
            <td>
              <strong>{{ $t('message.privacyPersonalInfo01Table02ColName02') }}</strong>
            </td>
            <td>
              <strong>{{ $t('message.privacyPersonalInfo01Table02ColName03') }}</strong>
            </td>
          </tr>
        </thead>
        <tbody>
          <!-- 表格主体 -->
          <tr>
            <td class="personalInfoTb3Col01">{{ $t('message.privacyPersonalInfo01Table02.typeOfData') }}</td>
            <td class="personalInfoTb3Col02">{{ $t('message.privacyPersonalInfo01Table02.examplesOfData') }}</td>
            <td class="personalInfoTb3Col03">{{ $t('message.privacyPersonalInfo01Table02.purposes') }}</td>
          </tr>
        </tbody>
      </table>
      <br />
      <h3>{{ $t('message.privacyPersonalInfo02Title') }}</h3>
      <p>{{ $t('message.privacyPersonalInfo02Paragraph01') }}</p>
      <table>
        <thead>
          <!-- 表格头部 -->
          <tr>
            <td>
              <strong>{{ $t('message.privacyPersonalInfo02TableColName01') }}</strong>
            </td>
            <td>
              <strong>{{ $t('message.privacyPersonalInfo02TableColName02') }}</strong>
            </td>
          </tr>
        </thead>
        <tbody>
          <!-- 表格主体 -->
          <tr>
            <td class="personalInfoTb2Col01">{{ $t('message.privacyPersonalInfo02Table.typeOfData[0]') }}</td>
            <td class="personalInfoTb2Col02">{{ $t('message.privacyPersonalInfo02Table.examplesOfData[0]') }}</td>
          </tr>
          <tr>
            <td class="personalInfoTb2Col01">{{ $t('message.privacyPersonalInfo02Table.typeOfData[1]') }}</td>
            <td class="personalInfoTb2Col02">{{ $t('message.privacyPersonalInfo02Table.examplesOfData[1]') }}</td>
          </tr>
          <tr>
            <td class="personalInfoTb2Col01">{{ $t('message.privacyPersonalInfo02Table.typeOfData[2]') }}</td>
            <td class="personalInfoTb2Col02">{{ $t('message.privacyPersonalInfo02Table.examplesOfData[2]') }}</td>
          </tr>
          <tr>
            <td class="personalInfoTb2Col01">{{ $t('message.privacyPersonalInfo02Table.typeOfData[3]') }}</td>
            <td class="personalInfoTb2Col02">{{ $t('message.privacyPersonalInfo02Table.examplesOfData[3]') }}</td>
          </tr>
          <tr>
            <td class="personalInfoTb2Col01">{{ $t('message.privacyPersonalInfo02Table.typeOfData[4]') }}</td>
            <td class="personalInfoTb2Col02">{{ $t('message.privacyPersonalInfo02Table.examplesOfData[4]') }}</td>
          </tr>
          <tr>
            <td class="personalInfoTb2Col01">{{ $t('message.privacyPersonalInfo02Table.typeOfData[5]') }}</td>
            <td class="personalInfoTb2Col02">{{ $t('message.privacyPersonalInfo02Table.examplesOfData[5]') }}</td>
          </tr>
          <tr>
            <td class="personalInfoTb2Col01">{{ $t('message.privacyPersonalInfo02Table.typeOfData[6]') }}</td>
            <td class="personalInfoTb2Col02">{{ $t('message.privacyPersonalInfo02Table.examplesOfData[6]') }}</td>
          </tr>
          <tr>
            <td class="personalInfoTb2Col01">{{ $t('message.privacyPersonalInfo02Table.typeOfData[7]') }}</td>
            <td class="personalInfoTb2Col02">{{ $t('message.privacyPersonalInfo02Table.examplesOfData[7]') }}</td>
          </tr>
          <tr>
            <td class="personalInfoTb2Col01">{{ $t('message.privacyPersonalInfo02Table.typeOfData[8]') }}</td>
            <td class="personalInfoTb2Col02">{{ $t('message.privacyPersonalInfo02Table.examplesOfData[8]') }}</td>
          </tr>
        </tbody>
      </table>
      <p>{{ $t('message.privacyPersonalInfo02Paragraph02') }}</p>
    </div>

    <!-- 3. Purposes -->
    <div class="purposes">
      <h2>{{ $t('message.privacyPurposesTitle') }}</h2>
      <p>{{ $t('message.privacyPurposesParagraph01') }}</p>
      <p>{{ $t('message.privacyPurposesParagraph02') }}</p>
      <table>
        <thead>
          <!-- 表格头部 -->
          <tr>
            <td>
              <strong>{{ $t('message.privacyPurposesTableColName01') }}</strong>
            </td>
            <td>
              <strong>{{ $t('message.privacyPurposesTableColName02') }}</strong>
            </td>
          </tr>
        </thead>
        <tbody>
          <!-- 表格主体 -->
          <tr>
            <td class="purposesTb2Col01">{{ $t('message.privacyPurposesTable.purposes[0]') }}</td>
            <td class="purposesTb2Col02">{{ $t('message.privacyPurposesTable.legalBasis[0]') }}</td>
          </tr>
          <tr>
            <td class="purposesTb2Col01">{{ $t('message.privacyPurposesTable.purposes[1]') }}</td>
            <td class="purposesTb2Col02">{{ $t('message.privacyPurposesTable.legalBasis[1]') }}</td>
          </tr>
          <tr>
            <td class="purposesTb2Col01">{{ $t('message.privacyPurposesTable.purposes[2]') }}</td>
            <td class="purposesTb2Col02">{{ $t('message.privacyPurposesTable.legalBasis[2]') }}</td>
          </tr>
          <tr>
            <td class="purposesTb2Col01">{{ $t('message.privacyPurposesTable.purposes[3]') }}</td>
            <td class="purposesTb2Col02">{{ $t('message.privacyPurposesTable.legalBasis[3]') }}</td>
          </tr>
          <tr>
            <td class="purposesTb2Col01">{{ $t('message.privacyPurposesTable.purposes[4]') }}</td>
            <td class="purposesTb2Col02">{{ $t('message.privacyPurposesTable.legalBasis[4]') }}</td>
          </tr>
          <tr>
            <td class="purposesTb2Col01">{{ $t('message.privacyPurposesTable.purposes[5]') }}</td>
            <td class="purposesTb2Col02">{{ $t('message.privacyPurposesTable.legalBasis[5]') }}</td>
          </tr>
          <tr>
            <td class="purposesTb2Col01">{{ $t('message.privacyPurposesTable.purposes[6]') }}</td>
            <td class="purposesTb2Col02">{{ $t('message.privacyPurposesTable.legalBasis[6]') }}</td>
          </tr>
          <tr>
            <td class="purposesTb2Col01">{{ $t('message.privacyPurposesTable.purposes[7]') }}</td>
            <td class="purposesTb2Col02">{{ $t('message.privacyPurposesTable.legalBasis[7]') }}</td>
          </tr>
          <tr>
            <td class="purposesTb2Col01">{{ $t('message.privacyPurposesTable.purposes[8]') }}</td>
            <td class="purposesTb2Col02">{{ $t('message.privacyPurposesTable.legalBasis[8]') }}</td>
          </tr>
          <tr>
            <td class="purposesTb2Col01">{{ $t('message.privacyPurposesTable.purposes[9]') }}</td>
            <td class="purposesTb2Col02">{{ $t('message.privacyPurposesTable.legalBasis[9]') }}</td>
          </tr>
          <tr>
            <td class="purposesTb2Col01">{{ $t('message.privacyPurposesTable.purposes[10]') }}</td>
            <td class="purposesTb2Col02">{{ $t('message.privacyPurposesTable.legalBasis[10]') }}</td>
          </tr>
          <tr>
            <td class="purposesTb2Col01">{{ $t('message.privacyPurposesTable.purposes[2]') }}</td>
            <td class="purposesTb2Col02">{{ $t('message.privacyPurposesTable.legalBasis[2]') }}</td>
          </tr>
        </tbody>
      </table>
      <p>{{ $t('message.privacyPurposesParagraph03') }}</p>
      <p>{{ $t('message.privacyPurposesParagraph04') }}</p>
      <p>{{ $t('message.privacyPurposesParagraph05') }}</p>
    </div>

    <!-- 4. Disclose -->
    <div class="disclose">
      <h2>{{ $t('message.privacyDiscloseTitle') }}</h2>
      <p>{{ $t('message.privacyDiscloseParagraph01') }}</p>
      <p>{{ $t('message.privacyDiscloseParagraph02') }}</p>
      <p>{{ $t('message.privacyDiscloseParagraph03') }}</p>
      <table>
        <thead>
          <!-- 表格头部 -->
          <tr>
            <td>
              <strong>{{ $t('message.privacyDiscloseTableColName01') }}</strong>
            </td>
            <td>
              <strong>{{ $t('message.privacyDiscloseTableColName02') }}</strong>
            </td>
            <td>
              <strong>{{ $t('message.privacyDiscloseTableColName03') }}</strong>
            </td>
          </tr>
        </thead>
        <tbody>
          <!-- 表格主体 -->
          <tr>
            <td class="discloseTb3Col01">{{ $t('message.privacyDiscloseTable.recipients[0]') }}</td>
            <td class="discloseTb3Col02">
              <ul>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes01[0]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes01[1]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes01[2]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes01[3]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes01[4]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes01[5]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes01[6]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes01[7]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes01[8]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes01[9]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes01[10]') }}</li>
              </ul>
            </td>
            <td class="discloseTb3Col03">{{ $t('message.privacyDiscloseTable.categories[0]') }}</td>
          </tr>

          <tr>
            <td class="discloseTb3Col01">{{ $t('message.privacyDiscloseTable.recipients[1]') }}</td>
            <td class="discloseTb3Col02">
              <ul>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes02[0]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes02[1]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes02[2]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes02[3]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes02[4]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes02[5]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes02[6]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes02[7]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes02[8]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes02[9]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes02[10]') }}</li>
              </ul>
            </td>
            <td class="discloseTb3Col03">{{ $t('message.privacyDiscloseTable.categories[1]') }}</td>
          </tr>

          <tr>
            <td class="discloseTb3Col01">{{ $t('message.privacyDiscloseTable.recipients[2]') }}</td>
            <td class="discloseTb3Col02" id="disclosePurposes03Special">{{ $t('message.privacyDiscloseTable.purposes.purposes03') }}</td>
            <td class="discloseTb3Col03">{{ $t('message.privacyDiscloseTable.categories[2]') }}</td>
          </tr>

          <tr>
            <td class="discloseTb3Col01">{{ $t('message.privacyDiscloseTable.recipients[3]') }}</td>
            <td class="discloseTb3Col02">
              <ul>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes04[0]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes04[1]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes04[2]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes04[3]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes04[4]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes04[5]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes04[6]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes04[7]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes04[8]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes04[9]') }}</li>
                <li>{{ $t('message.privacyDiscloseTable.purposes.purposes04[10]') }}</li>
              </ul>
            </td>
            <td class="discloseTb3Col03">{{ $t('message.privacyDiscloseTable.categories[3]') }}</td>
          </tr>

          <tr>
            <td class="discloseTb3Col01">{{ $t('message.privacyDiscloseTable.recipients[4]') }}</td>
            <td class="discloseTb3Col02" id="disclosePurposes03Special">{{ $t('message.privacyDiscloseTable.purposes.purposes05') }}</td>
            <td class="discloseTb3Col03">{{ $t('message.privacyDiscloseTable.categories[4]') }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 5. Data Retention -->
    <div class="dataRetention">
      <h2>{{ $t('message.privacyDataRetentionTitle') }}</h2>
      <p>{{ $t('message.privacyDataRetentionParagraph01') }}</p>
      <p>{{ $t('message.privacyDataRetentionParagraph02') }}</p>
    </div>

    <!-- 6. Security -->
    <div class="security">
      <h2>{{ $t('message.privacySecurityTitle') }}</h2>
      <p>{{ $t('message.privacySecurityParagraph01') }}</p>
    </div>

    <!-- 7. Cookies and trackers -->
    <div class="cookies">
      <h2>{{ $t('message.privacyCookiesTitle') }}</h2>
      <p class="cookiesSpecialPadding">{{ $t('message.privacyCookiesParagraph01') }}</p>
      <p>{{ $t('message.privacyCookiesParagraph02') }}</p>
      <ul>
        <li>{{ $t('message.privacyCookiesEssentialList[0]') }}</li>
        <li>{{ $t('message.privacyCookiesEssentialList[1]') }}</li>
        <li>{{ $t('message.privacyCookiesEssentialList[2]') }}</li>
        <li>{{ $t('message.privacyCookiesEssentialList[3]') }}</li>
      </ul>
      <p>{{ $t('message.privacyCookiesParagraph03') }}</p>
      <ul class="cookiesSpecialPadding">
        <li>{{ $t('message.privacyCookiesEssentialList[0]') }}</li>
        <li>{{ $t('message.privacyCookiesEssentialList[1]') }}</li>
        <li>{{ $t('message.privacyCookiesEssentialList[2]') }}</li>
        <li>{{ $t('message.privacyCookiesEssentialList[3]') }}</li>
      </ul>
    </div>

    <!-- 8. Children -->
    <div class="children">
      <h2>{{ $t('message.privacyChildrenTitle') }}</h2>
      <p>{{ $t('message.privacyChildrenParagraph01') }}</p>
    </div>

    <!-- 9. Privacy Notice Revision -->
    <div class="noticeRevision">
      <h2>{{ $t('message.privacyNoticeRevisionTitle') }}</h2>
      <p>{{ $t('message.privacyNoticeRevisionParagraph01') }}</p>
    </div>

    <!-- 10. Contacts -->
    <div class="contacts">
      <h2>{{ $t('message.privacyContactsTitle') }}</h2>
      <p>{{ $t('message.privacyContactsParagraph01') }}</p>
      <br />
      <h3>{{ $t('message.privacyContactsLocationShaoxing.name') }}</h3>
      <p>{{ $t('message.privacyContactsLocationShaoxing.att') }}</p>
      <p>{{ $t('message.privacyContactsLocationShaoxing.email') }}</p>
      <p>{{ $t('message.privacyContactsLocationShaoxing.phone') }}</p>
      <br />
      <br />
      <h3>{{ $t('message.privacyContactsLocationHangzhou.name') }}</h3>
      <p>{{ $t('message.privacyContactsLocationHangzhou.att') }}</p>
      <p>{{ $t('message.privacyContactsLocationHangzhou.email') }}</p>
      <br />
      <br />
      <h3>{{ $t('message.privacyContactsLocationJinhua.name') }}</h3>
      <p>{{ $t('message.privacyContactsLocationJinhua.att') }}</p>
      <p>{{ $t('message.privacyContactsLocationJinhua.email') }}</p>
      <br />
      <br />
      <h3>{{ $t('message.privacyContactsLocationShenzhen.name') }}</h3>
      <p>{{ $t('message.privacyContactsLocationShenzhen.att') }}</p>
      <p>{{ $t('message.privacyContactsLocationShenzhen.email') }}</p>
    </div>

    <br />
    <br />
    <br />
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.privacy {
  background: white;
  font-family: 'D-DIN-PRO', sans-serif;
  width: 63vw;
  margin: 0 auto;
}

.title {
  text-align: center;
  margin-top: 10rem;
  margin-bottom: 5rem;
}
.title h1 {
  font-size: 4rem;
  color: black;
}
.title p {
  font-size: 1.25rem;
  color: #333;
  word-wrap: break-word; /* 换行不得拆散单词 */
}

.introduction {
  color: black;
  text-align: left;
}

.introduction h2 {
  font-size: 2.5rem;
}

.introduction p {
  font-size: 1.2rem;
  line-height: 1.7rem;
  padding-bottom: 2rem;
  word-wrap: break-word; /* 换行不得拆散单词 */
}

.personalInfo {
  color: black;
  text-align: left;
}

.personalInfo h2 {
  font-size: 2.5rem;
}

.personalInfo p {
  font-size: 1.2rem;
  line-height: 1.7rem;
  padding-bottom: 2rem;
  word-wrap: break-word; /* 换行不得拆散单词 */
}

.personalInfo table {
  border-collapse: collapse;
  display: table;
  width: 100%;
  table-layout: fixed;
  transform: scale(1);
}
.personalInfo td {
  font-size: 1.2em;
  padding: 1rem 0.75rem;
  border: 1px solid #000;
  line-height: 1.7rem;
}

.personalInfoTb2Col01 {
  width: 20rem;
}

.personalInfoTb2Col02 {
  width: 80rem;
}

.personalInfoTb3Col01 {
  width: 20rem;
}

.personalInfoTb3Col02 {
  width: 40rem;
}

.personalInfoTb3Col03 {
  width: 40rem;
}

.purposes {
  color: black;
  text-align: left;
  /* margin: 0rem 10rem; */
}

.purposes h2 {
  font-size: 2.5rem;
}

.purposes p {
  font-size: 1.2rem;
  line-height: 1.7rem;
  padding-bottom: 2rem;
  word-wrap: break-word; /* 换行不得拆散单词 */
}

.purposes table {
  border-collapse: collapse;
  display: table;
  width: 100%;
  table-layout: fixed;
  transform: scale(1);
}
.purposes td {
  font-size: 1.2em;
  padding: 1rem 0.75rem;
  border: 1px solid #000;
  line-height: 1.7rem;
}

.purposesTb2Col01 {
  width: 80rem;
}

.purposesTb2Col02 {
  width: 20rem;
}

.disclose {
  color: black;
  text-align: left;
  /* margin: 0rem 10rem; */
}

.disclose h2 {
  font-size: 2.5rem;
}

.disclose p {
  font-size: 1.2rem;
  line-height: 1.7rem;
  padding-bottom: 2rem;
  word-wrap: break-word; /* 换行不得拆散单词 */
}

.disclose table {
  border-collapse: collapse;
  /* display: table; */
  width: 100%;
  table-layout: fixed;
  transform: scale(1);
  /* -webkit-backface-visibility: hidden; */
  border-spacing: 0;
}
.disclose td {
  font-size: 1.2em;
  padding: 1rem 2rem;
  border: 1px solid #000;
  line-height: 1.7rem;
  white-space: normal;
}

.discloseTb3Col01 {
  width: 20rem;
}

.discloseTb3Col02 {
  width: 40rem;
}

.discloseTb3Col03 {
  width: 40rem;
  white-space: pre;
}

.dataRetention {
  color: black;
  text-align: left;
  /* margin: 0rem 10rem; */
}

.dataRetention h2 {
  font-size: 2.5rem;
}

.dataRetention p {
  font-size: 1.2rem;
  line-height: 1.7rem;
  padding-bottom: 2rem;
  word-wrap: break-word; /* 换行不得拆散单词 */
}

.security {
  color: black;
  text-align: left;
  /* margin: 0rem 10rem; */
}

.security h2 {
  font-size: 2.5rem;
}

.security p {
  font-size: 1.2rem;
  line-height: 1.7rem;
  padding-bottom: 2rem;
  word-wrap: break-word; /* 换行不得拆散单词 */
}

.cookies {
  color: black;
  text-align: left;
  /* margin: 0rem 10rem; */
}

.cookies h2 {
  font-size: 2.5rem;
}

.cookies p {
  font-size: 1.2rem;
  line-height: 1.7rem;
  /* padding-bottom: 2rem; */
  word-wrap: break-word; /* 换行不得拆散单词 */
}

.cookiesSpecialPadding {
  padding-bottom: 2rem;
}

.children {
  color: black;
  text-align: left;
  /* margin: 0rem 10rem; */
}

.children h2 {
  font-size: 2.5rem;
}

.children p {
  font-size: 1.2rem;
  line-height: 1.7rem;
  padding-bottom: 2rem;
  word-wrap: break-word; /* 换行不得拆散单词 */
}

.noticeRevision {
  color: black;
  text-align: left;
  /* margin: 0rem 10rem; */
}

.noticeRevision h2 {
  font-size: 2.5rem;
}

.noticeRevision p {
  font-size: 1.2rem;
  line-height: 1.7rem;
  padding-bottom: 2rem;
  word-wrap: break-word; /* 换行不得拆散单词 */
}

.contacts {
  color: black;
  text-align: left;
  font-size: 1.2rem;
  /* margin: 0rem 10rem; */
}

.contacts h2 {
  font-size: 2.5rem;
}

.contacts p {
  font-size: 1.2rem;
  line-height: 1.7rem;
  word-wrap: break-word; /* 换行不得拆散单词 */
}
ul {
  list-style-type: disc;
  padding-left: 20px;
  margin: 0;
  font-family: 'D-DIN-PRO', sans-serif;
  font-size: 1.2rem;
  line-height: 1.7rem;
}

@media (max-width: 768px) {
  .privacy {
    width: 92vw;
  }
  .disclose td {
    padding: 0rem 1rem;
  }
}
</style>